import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb9c97c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicators-statistic" }
const _hoisted_2 = {
  key: 0,
  class: "indicators-statistic__content"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "На этот временной промежуток запланированных пациентов нет", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { onBeforeMount, PropType, ref, toRaw, watch } from 'vue'
import IndicatorsStatistic from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatistic.vue'
import IndicatorsStatisticPatients from '@/widgets/WIndicatorsStatisticPatients/components/IndicatorsStatisticPatients.vue'
import {
  StatisticAppointmentTypeWithPatients,
  StatisticDoctorType,
} from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  patients: Array as PropType<StatisticAppointmentTypeWithPatients[]>,
  selectedDoctor: Object as PropType<StatisticDoctorType>,
},
  setup(__props) {

const props = __props



const currentPatientListNumber = ref(0)
const activePatientList = ref<StatisticAppointmentTypeWithPatients>()

const onPatientChartClick = (event, elements) => {
  if (elements.length < 1) {
    return
  }

  currentPatientListNumber.value = elements[0].index
}

const filterActivePatients = () => {
  if (props.selectedDoctor) {
    const rawPatients = toRaw(props.patients)

    activePatientList.value = {
      date: rawPatients[currentPatientListNumber.value].date,
      count: rawPatients[currentPatientListNumber.value].count,
      patients: [
        ...rawPatients[currentPatientListNumber.value].patients.filter(
          (patient) => patient.user_id == props.selectedDoctor.id
        ),
      ],
    }
  } else {
    updateActivePatientList()
  }
}

const updateActivePatientList = () => {
  if (props.patients.length > 0) {
    if (props.selectedDoctor) {
      filterActivePatients()
      return
    }

    const rawPatients = toRaw(props.patients)

    activePatientList.value = {
      date: rawPatients[currentPatientListNumber.value].date,
      count: rawPatients[currentPatientListNumber.value].count,
      patients: [...rawPatients[currentPatientListNumber.value].patients],
    }
  }
}

const resetChartColumnNumber = () => (currentPatientListNumber.value = 0)

watch(currentPatientListNumber, updateActivePatientList)
watch(
  () => props.patients,
  () => {
    if (currentPatientListNumber.value != 0) {
      resetChartColumnNumber()
    } else {
      // If it's already zero the update event won't fire so in this case it has to be triggered manually
      updateActivePatientList()
    }
  }
)
watch(() => props.selectedDoctor, filterActivePatients)

onBeforeMount(() => {
  updateActivePatientList()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.patients.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(IndicatorsStatistic, {
            reports: __props.patients,
            "on-chart-click": onPatientChartClick,
            class: "indicators-statistic__card"
          }, null, 8, ["reports"]),
          (activePatientList.value)
            ? (_openBlock(), _createBlock(IndicatorsStatisticPatients, {
                key: 0,
                selectedMonthStatistic: activePatientList.value
              }, null, 8, ["selectedMonthStatistic"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
  ]))
}
}

})